import React, { useEffect } from "react";
import styled from "styled-components";
import useSelfpointEffect from "../common3/hooks/useSelfpointEffect";
import { Link } from "react-router-dom";
import get from "lodash/get";
import filterString from "../common3/filterString";
import isEmpty from "lodash/isEmpty";
import isEqual from "lodash/isEqual";
import {
  Table,
  Wrapper,
  THead,
  TBody,
  TR,
  TD,
  TH,
  PLink,
  TableScrollWrapper,
  Top,
  Label,
} from "../Table/styled";

const TextTD = styled(TD)`
  padding: 10px 15px;
`;

const EffectTable = (props) => {
  const {
    extra = {},
    save,
    id,
    document = {},
    value = null,
    runEffect,
  } = props;
  const {
    configuration = [],
    saveTable = false,
    enableComponentFilter,
    componentFilterId,
    label,
  } = extra;

  let componentFilter = enableComponentFilter
    ? document && document[componentFilterId]
    : null;

  const watchArray = [];
  if (!isEmpty(document)) {
    watchArray.push(document);
  }
  if (componentFilter) {
    watchArray.push(componentFilter);
  }
  const [, effect] = useSelfpointEffect({
    ...props,
    context: {
      componentFilter,
    },
    ...(!isEmpty(watchArray) && { watchArray }),
  });

  const ticketLists = effect && effect.data ? effect.data : effect;

  useEffect(() => {
    if (saveTable) {
      const saveValue =
        ticketLists &&
        Array.isArray(ticketLists) &&
        ticketLists.map(
          (row) =>
            configuration &&
            configuration.map((col) => {
              const thisColumn = get(col, ["content"], "");

              return filterString(thisColumn, props, row);
            })
        );
      const hasNewValue = !isEqual(value, saveValue);
      if (!hasNewValue || !saveValue) {
        return;
      }
      save({ key: id, value: saveValue });
    }
  }, [ticketLists]);

  const onLinkClick = (rowData) => {
    const { linkEffect, index } = rowData;

    if (!linkEffect) {
      return;
    }

    runEffect({
      source: linkEffect,
      effectId: `${id}_linkEffect_${index}`,
      context: rowData,
      pageType: "multiEffect",
    });
  };

  return (
    <>
      <Top>
        <Label>{label}</Label>
      </Top>
      <Wrapper className="sp-effecttable">
        <TableScrollWrapper className="sp-effecttable-scroll-wrapper">
          <Table>
            <THead>
              <TR>
                {configuration &&
                  configuration.map((col, i) => {
                    const thisColumn = get(col, ["heading"], "");
                    return <TH key={`th${i}`}>{thisColumn}</TH>;
                  })}
              </TR>
            </THead>
            <TBody>
              {ticketLists &&
                Array.isArray(ticketLists) &&
                ticketLists.map((row, rowIndex) => {
                  return (
                    <TR key={`tr-${rowIndex}`}>
                      {configuration &&
                        configuration.map((col, colIndex) => {
                          const thisColumn = get(col, ["content"], "");
                          if (col.isLink) {
                            return (
                              <TextTD key={`td-${rowIndex}${colIndex}`}>
                                {col.withEffect ? (
                                  <PLink
                                    onClick={() =>
                                      onLinkClick({
                                        ...ticketLists[rowIndex],
                                        ...col,
                                        index: rowIndex,
                                      })
                                    }
                                  >
                                    {filterString(thisColumn, props, row)}
                                  </PLink>
                                ) : (
                                  <Link
                                    to={`${col.to}${
                                      col.toParams &&
                                      "?" +
                                        filterString(col.toParams, props, row)
                                    }`}
                                  >
                                    {filterString(thisColumn, props, row)}
                                  </Link>
                                )}
                              </TextTD>
                            );
                          }
                          return (
                            <TextTD key={`td-${rowIndex}${colIndex}`}>
                              {filterString(thisColumn, props, row)}
                            </TextTD>
                          );
                        })}
                    </TR>
                  );
                })}
            </TBody>
          </Table>
        </TableScrollWrapper>
      </Wrapper>
    </>
  );
};

export default EffectTable;
